import { render, staticRenderFns } from "./violation.page.vue?vue&type=template&id=b0c0324c&scoped=true&"
import script from "./violation.page.vue?vue&type=script&lang=js&"
export * from "./violation.page.vue?vue&type=script&lang=js&"
import style0 from "./violation.page.vue?vue&type=style&index=0&id=b0c0324c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0324c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0c0324c')) {
      api.createRecord('b0c0324c', component.options)
    } else {
      api.reload('b0c0324c', component.options)
    }
    module.hot.accept("./violation.page.vue?vue&type=template&id=b0c0324c&scoped=true&", function () {
      api.rerender('b0c0324c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comsTrade/violation.page.vue"
export default component.exports